module.exports = __webpack_public_path__ + "static/img/081_TO8_1728_og.43a664f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/081_TO8_1728_og.jpg
// module id = oNbs
// module chunks = 0